module.exports = __webpack_public_path__ + "876b703127143b9c01d2be0a911c23c0.png";